import { render, staticRenderFns } from "./OrderChecklistDetailsDialog.vue?vue&type=template&id=287b2fc9&"
import script from "./OrderChecklistDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderChecklistDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports